import { isRedoEmployeeEmail } from "@redotech/account-common/redo-employee";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { memo, useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Beta gate for Redo-employee-only routes (the server enforces the same rule
 * on the RPC); renders nothing until the user is known, then redirects others.
 */
export const RedoEmployeeGate = memo(function RedoEmployeeGate({
  fallbackTo = "..",
}: {
  fallbackTo?: string;
}) {
  const user = useContext(UserContext);
  if (!user) {
    return null;
  }
  if (!isRedoEmployeeEmail(user.email)) {
    return <Navigate replace to={fallbackTo} />;
  }
  return <Outlet />;
});
